require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/fn/object/assign.js
 ** module id = 101
 ** module chunks = 0
 **/